import { FormattedEvent, getEventsById } from '@eventbrite/event-renderer';
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_EXPANSIONS } from '../../../../redux/api/expansions';

export const getInitialEvents = (transformedBuckets: any[]) => {
    const initialEvents: FormattedEvent[] = [];

    for (let i = 0; i < transformedBuckets.length; i++) {
        if (transformedBuckets[i]?.content) {
            const filteredEvents = transformedBuckets[i].content.filter(
                (event: { isPromoted: boolean }) => !event.isPromoted,
            );
            const eventsToPush = Math.min(filteredEvents.length, 8);

            initialEvents.push(...filteredEvents.slice(0, eventsToPush));
        }
    }

    return initialEvents;
};

interface UseTopBannerEventExpansionsProps {
    content: FormattedEvent[];
    bucketKey: string;
    type: string;
}

export const useTopBannerEventExpansions = ({
    content,
    bucketKey,
    type,
}: UseTopBannerEventExpansionsProps) => {
    const eventIds = type === 'event' ? content.map(({ id }) => id) : [];

    return useQuery(
        ['expandTopBannerEvents', bucketKey],
        async () => {
            const response = await getEventsById(
                eventIds,
                50,
                DEFAULT_EXPANSIONS,
            );
            return response.events;
        },
        {
            select: (data) => {
                return content.map((event) => {
                    const extendedEvent = data.find(
                        (expandedEvent) => expandedEvent.id === event.id,
                    );
                    return {
                        ...event,
                        ...extendedEvent,
                    };
                });
            },
            onError: (error) => {
                console.log(error);
            },
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: 150000,
        },
    );
};
